import styled from "styled-components/native";
import {
  variant,
  colorProps,
  ColorProps,
  fontFamilyProps,
  FontFamilyProps,
  fontSizeProps,
  FontSizeProps,
} from "@sloth-system/props";

export { Typography };

type TypographyStyleProps = FontFamilyProps &
  FontSizeProps &
  ColorProps & {
    alignment?: "right" | "center" | "left";
    children: string;
  };

let alignmentVariant = variant("alignment", {
  right: `text-align: right;`,
  center: `text-align: center;`,
  left: `text-align: left;`,
});

let Typography = styled.Text<TypographyStyleProps>`
  ${fontFamilyProps}
  ${fontSizeProps}
  ${colorProps}
  ${alignmentVariant}
`;

Typography.defaultProps = {
  ff: "main",
  alignment: "right",
  fs: "m",
};
